<script setup>

import Modal from "@/components/modal/Modal";
import {useMutation} from "@vue/apollo-composable";
import * as yup from "yup";
import {HpoSetDestinationHospitalMutation} from "@/graphql/mutations/hpo/patient/transportDestination.graphql"
import {numberValidator, requiredMessage} from "../../../utils/yupValidators";
import NumberSplitInput from "../../forms/NumberSplitInput.vue";
import {pgettext} from "../../../utils/translate";
import {useDjangoForm} from "../../../utils/forms";
import {Priority} from "../choices";
import {priorityColor} from "../utils";


const props = defineProps({
    patient: {
        type: Object,
        required: true
    },
    hospitalList: {
        type: Array,
        required: true,
    },
})

const emit = defineEmits(['close'])

const {defineField, handleMutationSubmit} = useDjangoForm({
    validationSchema: yup.object({
        hospital: numberValidator.required(requiredMessage),
        transportMinutes: numberValidator.required(requiredMessage).min(1, gettext('Value must be greater than 0'))
    }),
    initialValues: {
        hospital: null,
        transportMinutes: null
    }
});

const [hospital, hospitalProps] = defineField('hospital');
const [transportMinutes, transportMinutesProps] = defineField('transportMinutes');


const {mutate: hpoSetDestinationHospital} = useMutation(HpoSetDestinationHospitalMutation);


const onSubmit = handleMutationSubmit((values) => {
    return hpoSetDestinationHospital({
        patientId: props.patient.id,
        priority: props.patient.transportPriority,
        ...values
    });
}, {
    onSuccess() {
        close();
    },
    onMutationError(error) {
        alert(error);
    }
});


function close() {
    emit('close')
}

</script>

<template>
    <Modal :title="pgettext('label', 'Destination of patient') +': '+ patient.tic"
           @close="close"
           :closeOnClickOutside="false">

        <h3 :style="{ backgroundColor: priorityColor(patient.transportPriority) }"
        class="pa-3 mb-2">
            {{pgettext('label', 'Transport priority')}}: {{Priority[patient.transportPriority]}}
        </h3>

        <v-form @submit.prevent="onSubmit">
            <v-select v-model="hospital"
                      v-bind="hospitalProps"
                      :label="pgettext('label', 'Destination Hospital')"
                      :items="hospitalList"
                      item-value="id"
                      item-title="name"
            />

            <NumberSplitInput v-model="transportMinutes"
                              v-bind="transportMinutesProps"
                              class="mb-2"
                              :label="pgettext('label', 'ETA to Destination Hospital in minutes')"
                              :min="1"/>

            <v-btn block type="submit"
                   :text="pgettext('action', 'Submit')">
            </v-btn>
        </v-form>
    </Modal>

</template>

